export default function createSelectModelOptions(models, brandsFilter) {
  if(brandsFilter.length > 0) {
    return models
      .filter(model => brandsFilter.includes(model?.brand?.name))
      .map(model => ({
      label: model.name,
      value: model.name,
    }));
  }
  return models.map(model => ({
    label: model.name,
    value: model.name,
  }));
}
